import { PERMISSION_KEYS } from './permissionKeys'

export function hasPermission(effectivePermissionKeys, permissionKey) {
  if (!permissionKey) return false
  return Array.isArray(effectivePermissionKeys) && effectivePermissionKeys.includes(permissionKey)
}

export function hasAnyPermission(effectivePermissionKeys, permissionKeys) {
  if (!Array.isArray(permissionKeys) || permissionKeys.length === 0) return true
  return permissionKeys.some((key) => hasPermission(effectivePermissionKeys, key))
}

export function hasAllPermissions(effectivePermissionKeys, permissionKeys) {
  if (!Array.isArray(permissionKeys) || permissionKeys.length === 0) return true
  return permissionKeys.every((key) => hasPermission(effectivePermissionKeys, key))
}

export function isPlatformAdmin(effectivePermissionKeys) {
  return hasPermission(effectivePermissionKeys, PERMISSION_KEYS.PLATFORM_ADMIN_ACCESS)
}
